import type { DesignTemplate } from '~/modules/query/notification/types';

/** Designs per picker page; ui-design's email grid uses the same. */
export const DESIGN_PAGE_SIZE = 24;

/**
 * The `GET /design-templates` params for one page. service-notification limits the list to email
 * designs in Back At You's library (customer 0) and matches `name` case-insensitively.
 */
export function designListParams(name: string, pageIndex: number): Record<string, string | number> {
  const term = name.trim();
  return {
    ...(term ? { name: term } : {}),
    limit: DESIGN_PAGE_SIZE,
    offset: pageIndex * DESIGN_PAGE_SIZE,
  };
}

/** A design's name, or its id when it has none. */
export const designName = (design: DesignTemplate): string => design.name || design.id;
